var _g, _path, _rect, _rect2, _rect3, _path2, _g2, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _g3, _path3, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScale = function SvgScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 488 471"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#scale_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342.895,
    height: 396.971,
    x: 57,
    y: 27,
    fill: "#fff",
    rx: 9.797
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M57 160.962h342.895v124.13H57z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49.16,
    height: 49.16,
    x: 90.184,
    y: 196.604,
    fill: "#E2FFEA",
    opacity: 0.5,
    rx: 7.374
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 39.328,
    height: 39.328,
    x: 95.1,
    y: 201.52,
    fill: "#E2FFEA",
    rx: 7.374
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28.267,
    height: 28.267,
    x: 100.63,
    y: 207.051,
    fill: "#51C394",
    stroke: "#51C394",
    strokeWidth: 1.229,
    rx: 6.76
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.458,
    d: "m107.39 221.184 4.916 4.916 9.832-9.832"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#scale_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.518,
    height: 59.518,
    fill: "#3BBDCF",
    rx: 16,
    transform: "matrix(-1 0 0 1 438.519 65)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 270.235,
    height: 98.37,
    x: 94.436,
    y: 52.146,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 1.131,
    rx: 8.48
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 244.23,
    height: 11.307,
    x: 107.439,
    y: 65.149,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 94.978,
    height: 11.307,
    x: 107.439,
    y: 85.5,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 146.99,
    height: 11.307,
    x: 107.439,
    y: 126.206,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 88.194,
    height: 11.307,
    x: 263.475,
    y: 126.206,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 120.984,
    height: 11.307,
    x: 107.439,
    y: 105.854,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 27.137,
    height: 11.307,
    x: 237.469,
    y: 105.854,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 78.018,
    height: 11.307,
    x: 273.651,
    y: 105.854,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 140.206,
    height: 11.307,
    x: 211.463,
    y: 85.5,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 270.235,
    height: 98.37,
    x: 94.436,
    y: 295.49,
    fill: "#fff",
    stroke: "#EDEDED",
    strokeWidth: 1.131,
    rx: 8.48
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 244.23,
    height: 11.307,
    x: 107.439,
    y: 308.493,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 94.978,
    height: 11.307,
    x: 107.439,
    y: 328.844,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 146.99,
    height: 11.307,
    x: 107.439,
    y: 369.55,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 88.194,
    height: 11.307,
    x: 263.475,
    y: 369.55,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 120.984,
    height: 11.307,
    x: 107.439,
    y: 349.198,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 27.137,
    height: 11.307,
    x: 237.469,
    y: 349.198,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 78.018,
    height: 11.307,
    x: 273.651,
    y: 349.198,
    fill: "#EDEDED",
    rx: 5.653
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 140.206,
    height: 11.307,
    x: 211.463,
    y: 328.844,
    fill: "#EDEDED",
    rx: 5.653
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#scale_svg__c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.518,
    height: 34.518,
    fill: "#3B7CC9",
    rx: 9.279,
    transform: "matrix(-1 0 0 1 74.519 335)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M51.504 344.502a.876.876 0 0 0-.876.876v10.507a3.5 3.5 0 0 0 3.502 3.502h8.757c1.336 0 2.255-.576 2.811-1.349.525-.728.69-1.575.69-2.153a.876.876 0 0 0-.875-.876h-2.627v-9.631a.876.876 0 0 0-.876-.876zm9.63 10.507v-8.755H52.38v9.631c0 .962.777 1.744 1.737 1.751h.015c.297 0 .763-.097 1.13-.36.322-.232.62-.626.62-1.391 0-.484.393-.876.876-.876zm1.752 2.627H57.22c.141-.26.251-.552.322-.876h6.886a2 2 0 0 1-.15.255c-.232.322-.626.621-1.392.621m-8.756-8.756c0-.483.392-.875.875-.875h3.503a.875.875 0 1 1 0 1.751h-3.503a.876.876 0 0 1-.875-.876m.875 1.752a.875.875 0 1 0 0 1.751h3.503a.876.876 0 0 0 0-1.751z",
    clipRule: "evenodd"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 270.235,
    height: 98.37,
    x: 152.2,
    y: 172.589,
    fill: "#fff",
    stroke: "#51C394",
    strokeWidth: 1.131,
    rx: 8.48
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 244.23,
    height: 11.307,
    x: 165.203,
    y: 185.592,
    fill: "#E2FFEA",
    rx: 5.653
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 94.978,
    height: 11.307,
    x: 165.203,
    y: 205.943,
    fill: "#E2FFEA",
    rx: 5.653
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 146.99,
    height: 11.307,
    x: 165.203,
    y: 246.649,
    fill: "#E2FFEA",
    rx: 5.653
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 88.194,
    height: 11.307,
    x: 321.238,
    y: 246.649,
    fill: "#E2FFEA",
    rx: 5.653
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 120.984,
    height: 11.307,
    x: 165.203,
    y: 226.297,
    fill: "#E2FFEA",
    rx: 5.653
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 27.137,
    height: 11.307,
    x: 295.232,
    y: 226.297,
    fill: "#E2FFEA",
    rx: 5.653
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 78.018,
    height: 11.307,
    x: 331.415,
    y: 226.297,
    fill: "#E2FFEA",
    rx: 5.653
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 140.206,
    height: 11.307,
    x: 269.227,
    y: 205.943,
    fill: "#E2FFEA",
    rx: 5.653
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M397.06 94.567c0 6.494 4.708 10.918 9.997 11.833a1.1 1.1 0 0 1 .719.455 1.12 1.12 0 0 1 .186.831 1.1 1.1 0 0 1-.455.719 1.1 1.1 0 0 1-.83.186c-6.21-1.075-11.84-6.31-11.84-14.024 0-3.28 1.491-5.856 3.232-7.815 1.248-1.403 2.675-2.545 3.823-3.417h-3.49a1.07 1.07 0 0 1-1.067-1.067 1.067 1.067 0 0 1 1.067-1.067h6.4a1.066 1.066 0 0 1 1.066 1.067v6.4a1.066 1.066 0 1 1-2.133 0V84.73l-.002.004c-1.22.918-2.709 2.042-4 3.495-1.525 1.715-2.673 3.79-2.673 6.338m23.697.866c0-6.426-4.608-10.823-9.828-11.804a1.113 1.113 0 0 1-.743-1.707 1.1 1.1 0 0 1 .714-.48 1.1 1.1 0 0 1 .438.003c6.131 1.152 11.642 6.357 11.642 13.988 0 3.279-1.491 5.854-3.232 7.814-1.248 1.404-2.675 2.545-3.823 3.418h3.49a1.066 1.066 0 1 1 0 2.133h-6.4a1.066 1.066 0 0 1-1.067-1.066v-6.4a1.07 1.07 0 0 1 1.067-1.067 1.066 1.066 0 0 1 1.067 1.067v3.936h.004c1.218-.922 2.709-2.044 3.998-3.499 1.525-1.713 2.673-3.787 2.673-6.336",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "scale_svg__a",
    width: 416.372,
    height: 470.449,
    x: 20.261,
    y: 0.261,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.369
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_587_15830"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_587_15830",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "scale_svg__b",
    width: 152.103,
    height: 152.102,
    x: 335.353,
    y: 29.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.645,
    dy: 10.581
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.146
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_587_15830"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_587_15830",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "scale_svg__c",
    width: 88.214,
    height: 88.213,
    x: 14.687,
    y: 314.289,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.534,
    dy: 6.137
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.424
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_587_15830"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_587_15830",
    result: "shape"
  })))));
};
export default SvgScale;